<template>
  <div class="standard-editor-panel">
    <!-- 主要内容区域 -->
    <div class="main-content-area">
      <!-- 顶部标题栏 -->
      <div class="header-bar">
        <div class="logo-section">
          <div class="logo-icon">
            <span class="logo-text">智</span>
          </div>
          <span class="system-title">智能标准文档编辑器</span>
        </div>
        <button class="download-btn" @click="downloadFile">
          <span>下载</span>
        </button>
      </div>

      <!-- 编辑器区域 -->
      <div class="editor-container">
        <!-- WPS在线编辑器容器 -->
        <div class="editor-frame-container">
          <div id="wps-editor" class="wps-editor-container"></div>
        </div>
      </div>
    </div>

    <!-- 右侧工具栏区域 -->
    <div class="tool-panel">
      <!-- 工具栏标题 -->
      <div class="tool-panel-header">
        <span class="tool-panel-title">智能标准编辑工具</span>
      </div>

      <!-- AI已完成的功能区域 -->
      <div class="ai-completed-features">
        <div class="completed-features-grid">
          <div class="completed-feature-item">
            <div class="completed-icon icon-2-small"></div>
            <span class="completed-feature-name">目次</span>
            <div class="completed-check"></div>
          </div>
          <div class="completed-feature-item">
            <div class="completed-icon icon-3-small"></div>
            <span class="completed-feature-name">引言</span>
            <div class="completed-check"></div>
          </div>
          <div class="completed-feature-item">
            <div class="completed-icon icon-4-small"></div>
            <span class="completed-feature-name">前言</span>
            <div class="completed-check"></div>
          </div>
          <div class="completed-feature-item">
            <div class="completed-icon icon-5-small"></div>
            <span class="completed-feature-name">文献</span>
            <div class="completed-check"></div>
          </div>
          <div class="completed-feature-item">
            <div class="completed-icon icon-6-small"></div>
            <span class="completed-feature-name">索引</span>
            <div class="completed-check"></div>
          </div>
          <div class="completed-feature-item">
            <div class="completed-icon icon-7-small"></div>
            <span class="completed-feature-name">校验</span>
            <div class="completed-check"></div>
          </div>
        </div>
      </div>

      <!-- 工具按钮区域 -->
      <div class="tool-content">
        <div class="tool-grid">
          <!-- 移除了目次和引言按钮 -->
          <div class="tool-item active" @click="handleImageClick">
            <div class="tool-icon icon-8"></div>
            <span class="tool-name">图</span>
          </div>
          <div class="tool-item active" @click="handleTableClick">
            <div class="tool-icon icon-9"></div>
            <span class="tool-name">表</span>
          </div>

          <!-- 第二行工具 -->
          <!-- 移除了前言、文献和索引按钮 -->
          <div class="tool-item active" @click="handleUntitledClick">
            <div class="tool-icon icon-10"></div>
            <span class="tool-name">无题条</span>
          </div>
          <div class="tool-item active" @click="handleListItemClick">
            <div class="tool-icon icon-11"></div>
            <span class="tool-name">列项</span>
          </div>
          <div class="tool-item active" @click="handleTermClick">
            <div class="tool-icon icon-12"></div>
            <span class="tool-name">术语条</span>
          </div>

          <!-- 第三行工具 -->
          <!-- 移除了校验按钮 -->
          <div class="tool-item active" @click="handleClauseClick">
            <div class="tool-icon icon-13"></div>
            <span class="tool-name">条</span>
          </div>
          <div class="tool-item active" @click="insertChapter">
            <div class="tool-icon icon-14"></div>
            <span class="tool-name">章</span>
          </div>
          <div class="tool-item active" @click="insertParagraph">
            <div class="tool-icon icon-15"></div>
            <span class="tool-name">段</span>
          </div>

          <!-- 第四行工具 -->
          <div class="tool-item active" @click="handleAnnotationClick">
            <div class="tool-icon icon-16"></div>
            <span class="tool-name">标注</span>
          </div>
          <div class="tool-item active" @click="handleFootnoteClick">
            <div class="tool-icon icon-17"></div>
            <span class="tool-name">脚注</span>
          </div>
          <div class="tool-item active" @click="handleFormulaClick">
            <div class="tool-icon icon-18"></div>
            <span class="tool-name">公式</span>
          </div>

          <!-- 第五行工具 -->
          <div class="tool-item active" @click="handleAppendixClick">
            <div class="tool-icon icon-19"></div>
            <span class="tool-name">附录</span>
          </div>

          <!-- 第六行工具 -->
          <div class="tool-item active" @click="handleSymbolUnitClick">
            <div class="tool-icon icon-23"></div>
            <span class="tool-name">符号/单位</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 符号/单位选择弹窗 -->
    <div class="symbol-unit-dialog" v-if="showSymbolUnitDialog">
      <div class="dialog-content">
        <div class="dialog-header">
          <span class="dialog-title">符号/单位选择</span>
          <span class="close-btn" @click="showSymbolUnitDialog = false">×</span>
        </div>
        <div class="dialog-body">
          <div class="search-box">
            <input type="text" v-model="symbolSearchText" placeholder="搜索符号或单位..." @input="filterSymbols">
          </div>
          <div class="symbol-list">
            <div v-for="(item, index) in filteredSymbols" :key="index" class="symbol-item" @click="insertSymbol(item)">
              <span class="symbol">{{ item.symbol }}</span>
              <span class="unit-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPresetConfig } from '../utils/wps/wpsConfig.js';
import WebOfficeSDK from '../utils/web-office-sdk-solution-v1.1.27.es.js';

export default {
  name: 'StandardEditor',
  props: {
    fileName: {
      type: String,
      default: ''
    },
    fileId: {
      type: String,
      default: ''
    },
    wpsConfig: {
      type: Object,
      default: () => ({})
    },
    preset: {
      type: String,
      default: 'standard' // standard, simple, readonly
    }
  },
  data() {
    return {
      wpsApp: null, // WPS应用实例
      loadingTimer: null,
      pollingTimer: null, // 轮询定时器
      showSymbolUnitDialog: false, // 控制符号/单位弹窗显示
      symbolSearchText: '', // 符号搜索文本
      symbolUnitList: [
        { symbol: '>', name: '大于号' },
        { symbol: '<', name: '小于号' },
        { symbol: '≥', name: '大于等于号' },
        { symbol: '≤', name: '小于等于号' },
        { symbol: 'm', name: '米' },
        { symbol: 'kg', name: '千克(公斤)' },
        { symbol: 's', name: '秒' },
        { symbol: 'A', name: '安[培]' },
        { symbol: 'K', name: '开[尔文]' },
        { symbol: 'mol', name: '摩[尔]' },
        { symbol: 'cd', name: '坎[德拉]' },
        { symbol: 'Rad', name: '弧度' },
        { symbol: 'sr', name: '球面度' },
        { symbol: 'Hz', name: '赫[兹]' },
        { symbol: 'N', name: '牛[顿]' },
        { symbol: 'Pa', name: '帕[斯卡]' },
        { symbol: 'J', name: '焦[耳]' },
        { symbol: 'W', name: '瓦[特]' },
        { symbol: 'C', name: '库[伦]' },
        { symbol: 'V', name: '伏[特]' },
        { symbol: 'F', name: '法[拉]' },
        { symbol: 'Ω', name: '欧[姆]' },
        { symbol: 'S', name: '西[门子]' },
        { symbol: 'Wb', name: '韦[伯]' },
        { symbol: 'T', name: '特[斯拉]' },
        { symbol: 'H', name: '亨[利]' },
        { symbol: '℃', name: '摄氏度' },
        { symbol: 'lm', name: '流[明]' },
        { symbol: 'lx', name: '勒[克斯]' }
      ],
      filteredSymbols: [] // 过滤后的符号列表
    }
  },
  mounted() {
    // 初始化流程
    this.initializeEditor();
    // 初始化符号列表
    this.filteredSymbols = [...this.symbolUnitList];
  },
  methods: {
    // 初始化编辑器主流程
    async initializeEditor() {
      try {
        console.log('开始初始化编辑器流程');

        // 1. 确保编辑器容器已经渲染
        const editorContainer = await this.ensureEditorContainerReady();
        console.log('编辑器容器已就绪:', editorContainer);

        // 2. 初始化WPS编辑器
        await this.initWPSEditor(editorContainer);
      } catch (error) {
        console.error('编辑器初始化失败:', error);
        this.$message.error('编辑器初始化失败: ' + error.message);
      }
    },

    // 确保编辑器容器已经准备好
    ensureEditorContainerReady() {
      return new Promise((resolve) => {
        const checkContainer = () => {
          const container = document.getElementById('wps-editor');
          if (container) {
            console.log('编辑器容器已找到');
            resolve(container);
          } else {
            console.log('编辑器容器未找到，等待DOM渲染...');
            setTimeout(checkContainer, 100);
          }
        };

        checkContainer();
      });
    },

    // 初始化WPS编辑器
    async initWPSEditor(editorContainer) {
      try {
        // 验证 fileId 是否传入
        if (!this.fileId) {
          console.error('WPS编辑器初始化失败: 缺少 fileId 参数');
          this.$message.error('WPS编辑器初始化失败: 缺少文件ID');
          return;
        }

        console.log('开始初始化WPS编辑器，使用fileId:', this.fileId);

        // 使用简化的配置获取方式
        const config = getPresetConfig(this.preset, {
          mount: editorContainer,
          fileId: this.fileId, // 使用传入的WPS在线编辑器fileId
          // 确保我们使用配置的域名
          ...this.wpsConfig // 合并用户自定义配置
        });

        console.log('WPS配置:', config);

        // 初始化WPS应用，直接使用导入的WebOfficeSDK
        console.log('调用WebOfficeSDK.init开始初始化...');
        this.wpsApp = await WebOfficeSDK.init(config);
        console.log('WebOfficeSDK.init返回结果:', this.wpsApp);

        // 等待编辑器就绪
        console.log('等待编辑器就绪...');
        await this.wpsApp.ready();

        console.log('WPS编辑器已就绪，预设:', this.preset, '文件ID:', this.fileId);
        this.onEditorReady();

      } catch (error) {
        console.error('WPS编辑器初始化失败:', error);
        this.$message.error('WPS编辑器初始化失败，请检查配置或文件ID');
      }
    },

    // 编辑器就绪回调
    async onEditorReady() {
      console.log('编辑器已就绪，可以进行操作');
      const app = await this.wpsApp.Application;
      app.ActiveDocument.ActiveWindow.DocumentMap = false;
      // 可以在这里执行一些初始化操作
    },

    // 处理工具点击事件
    handleToolClick(toolName) {
      // 处理各种工具点击事件的逻辑
      console.log('点击了工具:', toolName);

      // 根据工具名称执行不同的操作
      switch (toolName) {
        case '章':
          this.insertChapter();
          break;
        case '段':
          this.insertParagraph();
          break;
        case '新建':
          this.test();
          break;
        default:
          this.$message.info(`功能 "${toolName}" 即将上线，敬请期待`);
          break;
      }
    },

    // 选中当前段落的所有内容
    async test() {
      try {
        const app = await this.wpsApp.Application;
        const selection = await app.ActiveDocument.ActiveWindow.Selection;
        // 选中当前段落
        await selection.Range.Paragraphs.SetHeader(2);
        console.log('已选中当前段落');
        this.$message.success('已选中当前段落');
      } catch (error) {
        console.error('选中段落失败:', error);
        this.$message.error('选中段落失败');
      }
    },

    // Add new methods for inserting text
    async insertChapter() {
      try {
        const app = await this.wpsApp.Application;
        const selection = await app.ActiveDocument.ActiveWindow.Selection;
        const font = await selection.Font;
        font.Name = '黑体';
        font.Size = 10.5; // 5号字
        font.Bold = true;
        await selection.InsertAfter('\n');
        await selection.InsertAfter('新建章节');
      } catch (error) {
        console.error('Failed to insert chapter:', error);
      }
    },

    async insertParagraph() {
      try {
        const app = await this.wpsApp.Application;
        const selection = await app.ActiveDocument.ActiveWindow.Selection;
        const font = await selection.Font;
        font.Name = '宋体';
        font.Size = 10.5; // 5号字
        font.Bold = false;
        await selection.InsertAfter('\n');
        await selection.InsertAfter('新建段落');
      } catch (error) {
        console.error('Failed to insert paragraph:', error);
      }
    },

    // 保存文档
    async saveDocument() {
      try {
        if (!this.wpsApp) {
          console.error('WPS编辑器未初始化');
          return;
        }

        await this.wpsApp.save();
        console.log('文档保存成功');
        this.$message.success('文档已保存');
      } catch (error) {
        console.error('保存文档失败:', error);
        this.$message.error('保存文档失败，请重试');
      }
    },

    async downloadFile() {
      try {
        // 先保存WPS编辑器中的当前内容
        this.$message({
          message: '正在保存当前编辑内容...',
          type: 'info'
        });

        await this.saveDocument();

        // 准备下载
        this.$message({
          message: '准备下载...',
          type: 'info'
        });

        // 实际调用API下载文件
        console.log('发送下载请求到: http://140.143.169.8:7777/api/file/download/' + this.fileId);

        // 创建下载链接
        const downloadUrl = `http://140.143.169.8:7777/api/file/download/${this.fileId}`;
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `${this.fileName || 'document'}.docx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('文件下载成功');
      } catch (error) {
        console.error('文件下载失败:', error);
        this.$message.error('文件下载失败，请重试');
      }
    },

    // 处理符号/单位按钮点击
    handleSymbolUnitClick() {
      this.showSymbolUnitDialog = true;
      this.symbolSearchText = '';
      this.filteredSymbols = [...this.symbolUnitList];
    },

    // 过滤符号列表
    filterSymbols() {
      if (!this.symbolSearchText) {
        this.filteredSymbols = [...this.symbolUnitList];
        return;
      }

      const searchText = this.symbolSearchText.toLowerCase();
      this.filteredSymbols = this.symbolUnitList.filter(item =>
        item.symbol.toLowerCase().includes(searchText) ||
        item.name.toLowerCase().includes(searchText)
      );
    },

    // 插入符号到文档
    async insertSymbol(item) {
      try {
        if (!this.wpsApp) {
          this.$message.error('编辑器未初始化');
          return;
        }

        const app = await this.wpsApp.Application;
        const selection = await app.ActiveDocument.ActiveWindow.Selection;

        // 插入符号
        await selection.InsertAfter(item.symbol);

        // 关闭弹窗
        this.showSymbolUnitDialog = false;

        this.$message.success(`已插入"${item.name}"`);
      } catch (error) {
        console.error('插入符号失败:', error);
        this.$message.error('插入符号失败');
      }
    },

    // 公共方法：插入标记并处理文档
    async insertMarkAndProcess(options) {
      const {
        markName,              // 标记名称，如 'formula', 'table', 'image'
        insertNewline = true,  // 是否插入换行符
        processingMessage = '正在处理，请稍候...', // 处理中的提示消息
        successMessage = '处理完成'  // 成功提示消息
      } = options;

      try {
        if (!this.wpsApp) {
          this.$message.error('编辑器未初始化');
          return false;
        }

        console.log(`开始处理${markName}插入...`);

        // 1. 获取文档选择区域
        const app = await this.wpsApp.Application;
        const selection = await app.ActiveDocument.ActiveWindow.Selection;

        // 2. 根据参数决定是否插入换行符
        if (insertNewline) {
          await selection.InsertAfter('\n');
        }

        // 3. 插入特殊标记 {{mark{markName}}}
        const markText = `{{mark${markName}}}`;
        await selection.InsertAfter(markText);

        console.log(`已插入${markName}标识: ${markText}`);
        this.$message.info(processingMessage);

        // 4. 执行保存文档操作
        await this.wpsApp.save();

        // 5. 调用服务端接口
        const response = await fetch(`http://140.143.169.8:7777/api/file/process/${this.fileId}`);
        if (response.ok) {
          const result = await response.json();
          if (result.status === 'success') {
            this.$message.success(successMessage);
            return true;
          }
        } else {
          console.error(`${markName}处理失败:`, response.status, response.statusText);
          this.$message.error(`${markName}处理失败，请重试`);
          return false;
        }

      } catch (error) {
        console.error(`${markName}处理过程中发生错误:`, error);
        this.$message.error(`${markName}处理失败: ` + error.message);
        return false;
      }
    },

    // 处理公式按钮点击（使用公共方法重构）
    async handleFormulaClick() {
      return await this.insertMarkAndProcess({
        markName: 'formula',
        insertNewline: true,
        processingMessage: '正在处理公式，请稍候...',
        successMessage: '公式处理完成'
      });
    },

    // 处理图片按钮点击
    async handleImageClick() {
      return await this.insertMarkAndProcess({
        markName: 'image',
        insertNewline: true,
        processingMessage: '正在处理图片，请稍候...',
        successMessage: '图片处理完成'
      });
    },

    // 处理表格按钮点击
    async handleTableClick() {
      return await this.insertMarkAndProcess({
        markName: 'table',
        insertNewline: true,
        processingMessage: '正在生成表格，请稍候...',
        successMessage: '表格生成完成'
      });
    },

    // 处理标注按钮点击
    async handleAnnotationClick() {
      return await this.insertMarkAndProcess({
        markName: 'annotation',
        insertNewline: true,
        processingMessage: '正在处理标注，请稍候...',
        successMessage: '标注处理完成'
      });
    },

    // 处理脚注按钮点击
    async handleFootnoteClick() {
      return await this.insertMarkAndProcess({
        markName: 'footnote',
        insertNewline: true,
        processingMessage: '正在处理脚注，请稍候...',
        successMessage: '脚注处理完成'
      });
    },

    // 处理无题条按钮点击
    async handleUntitledClick() {
      return await this.insertMarkAndProcess({
        markName: 'untitled',
        insertNewline: true,
        processingMessage: '正在处理无题条，请稍候...',
        successMessage: '无题条处理完成'
      });
    },

    // 处理列项按钮点击
    async handleListItemClick() {
      return await this.insertMarkAndProcess({
        markName: 'listitem',
        insertNewline: true,
        processingMessage: '正在处理列项，请稍候...',
        successMessage: '列项处理完成'
      });
    },

    // 处理术语条按钮点击
    async handleTermClick() {
      return await this.insertMarkAndProcess({
        markName: 'term',
        insertNewline: true,
        processingMessage: '正在处理术语条，请稍候...',
        successMessage: '术语条处理完成'
      });
    },

    // 处理条按钮点击
    async handleClauseClick() {
      return await this.insertMarkAndProcess({
        markName: 'clause',
        insertNewline: true,
        processingMessage: '正在处理条，请稍候...',
        successMessage: '条处理完成'
      });
    },

    // 处理附录按钮点击
    async handleAppendixClick() {
      return await this.insertMarkAndProcess({
        markName: 'appendix',
        insertNewline: true,
        processingMessage: '正在处理附录，请稍候...',
        successMessage: '附录处理完成'
      });
    },
  },
  beforeDestroy() {
    // 清理定时器
    if (this.loadingTimer) {
      clearInterval(this.loadingTimer);
      this.loadingTimer = null;
    }

    if (this.pollingTimer) {
      clearTimeout(this.pollingTimer);
      this.pollingTimer = null;
    }

    // 销毁WPS编辑器实例
    if (this.wpsApp) {
      this.wpsApp.destroy();
      this.wpsApp = null;
    }
  }
};
</script>

<style scoped>
.standard-editor-panel {
  display: flex;
  width: 100%;
  height: 100vh;
  background: #f5f7fa;
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 主要内容区域 */
.main-content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 800px;
  background: white;
  box-shadow: 0px 0px 16px 0px rgba(52, 91, 141, 0.1);
  border-radius: 8px;
  margin: 20px 0 20px 20px;
  overflow: hidden;
}

/* 顶部标题栏 */
.header-bar {
  background: linear-gradient(135deg, #7e57c2 0%, #9575cd 100%);
  padding: 16px 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.download-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  color: white;
  padding: 8px 16px;
  font-size: 14px;
  font-family: 'PingFang SC', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
}

.download-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.logo-icon {
  width: 36px;
  height: 36px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0px 0px 15px 0px rgba(173, 186, 255, 0.5);
}

.logo-text {
  color: #673ab7;
  font-size: 18px;
  font-weight: normal;
  font-family: 'PingFang SC', sans-serif;
}

.system-title {
  color: white;
  font-size: 18px;
  font-weight: normal;
  font-family: 'PingFang SC', sans-serif;
}

/* 编辑器区域 */
.editor-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}

.editor-frame-container {
  flex: 1;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.wps-editor-container {
  width: 100%;
  height: 100%;
  min-height: 500px;
  border: none;
  background: white;
  display: block;
  position: relative;
}

/* 右侧工具栏区域 */
.tool-panel {
  width: 400px;
  min-width: 320px;
  border-radius: 8px;
  margin: 20px 20px 20px 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  background: white;
  box-shadow: 0px 0px 16px 0px rgba(52, 91, 141, 0.1);
}

/* 工具栏标题 */
.tool-panel-header {
  background: linear-gradient(135deg, #7e57c2 0%, #9575cd 100%);
  padding: 16px 20px;
  border-radius: 8px 8px 0 0;
}

.tool-panel-title {
  color: white;
  font-size: 16px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
}

/* AI已完成功能区域 */
.ai-completed-features {
  padding: 15px 15px 5px;
  border-bottom: 1px solid #eee;
  background-color: #f9f9f9;
}

.completed-feature-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
}

.completed-features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.completed-feature-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  padding: 6px 5px;
  border-radius: 6px;
  background-color: #f0f0f0;
}

.completed-icon {
  width: 18px;
  height: 18px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-right: 5px;
}

.completed-feature-name {
  font-size: 12px;
  color: #666;
}

.completed-check {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 12px;
  height: 12px;
  background-color: #4CAF50;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.completed-check:after {
  content: '';
  display: block;
  width: 6px;
  height: 3px;
  border: 1.5px solid white;
  border-top: 0;
  border-right: 0;
  transform: rotate(-45deg);
  margin-top: -1px;
}

/* 工具内容区域 */
.tool-content {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
}

/* 网格布局 */
.tool-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.tool-item {
  width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #F6F6F6;
  box-shadow: 0px 0px 12px 0px rgba(64, 95, 152, 0.19);
  border-radius: 19px;
}

.tool-item.active {
  background: #f0f4ff;
  box-shadow: 0px 2px 8px rgba(100, 120, 200, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
}

.tool-item.active:hover {
  background: #e8eeff;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(100, 120, 200, 0.2);
}

.tool-item.disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.tool-icon {
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.tool-name {
  font-size: 13px;
  color: #333;
  font-family: 'PingFang SC', sans-serif;
}

/* 工具图标样式 */
.icon-1 {
  background-image: url('../assets/images/editIcons/1-active@2x.png');
}

.icon-2 {
  background-image: url('../assets/images/editIcons/2-active@2x.png');
}

.icon-3 {
  background-image: url('../assets/images/editIcons/3-active@2x.png');
}

.icon-4 {
  background-image: url('../assets/images/editIcons/4-disabled@2x.png');
}

.icon-5 {
  background-image: url('../assets/images/editIcons/5-disabled@2x.png');
}

.icon-6 {
  background-image: url('../assets/images/editIcons/6-disabled@2x.png');
}

.icon-7 {
  background-image: url('../assets/images/editIcons/7-disabled@2x.png');
}

.icon-8 {
  background-image: url('../assets/images/editIcons/8-disabled@2x.png');
  opacity: 1;
}

.icon-8.disabled {
  background-image: url('../assets/images/editIcons/8-disabled@2x.png');
  opacity: 0.6;
}

.icon-9 {
  background-image: url('../assets/images/editIcons/9-disabled@2x.png');
  opacity: 1;
}

.icon-9.disabled {
  background-image: url('../assets/images/editIcons/9-disabled@2x.png');
  opacity: 0.6;
}

.icon-10 {
  background-image: url('../assets/images/editIcons/10-disabled@2x.png');
  opacity: 1;
}

.icon-10.disabled {
  background-image: url('../assets/images/editIcons/10-disabled@2x.png');
  opacity: 0.6;
}

.icon-11 {
  background-image: url('../assets/images/editIcons/11-disabled@2x.png');
  opacity: 1;
}

.icon-11.disabled {
  background-image: url('../assets/images/editIcons/11-disabled@2x.png');
  opacity: 0.6;
}

.icon-12 {
  background-image: url('../assets/images/editIcons/12-disabled@2x.png');
  opacity: 1;
}

.icon-12.disabled {
  background-image: url('../assets/images/editIcons/12-disabled@2x.png');
  opacity: 0.6;
}

.icon-13 {
  background-image: url('../assets/images/editIcons/13-disabled@2x.png');
  opacity: 1;
}

.icon-13.disabled {
  background-image: url('../assets/images/editIcons/13-disabled@2x.png');
  opacity: 0.6;
}

.icon-14 {
  background-image: url('../assets/images/editIcons/14-active@2x.png');
}

.icon-14.disabled {
  background-image: url('../assets/images/editIcons/14-disabled@2x.png');
}

.icon-15 {
  background-image: url('../assets/images/editIcons/15-active@2x.png');
}

.icon-15.disabled {
  background-image: url('../assets/images/editIcons/15-disabled@2x.png');
}

.icon-16 {
  background-image: url('../assets/images/editIcons/16-disabled@2x.png');
  opacity: 1;
}

.icon-16.disabled {
  background-image: url('../assets/images/editIcons/16-disabled@2x.png');
  opacity: 0.6;
}

.icon-17 {
  background-image: url('../assets/images/editIcons/17-disabled@2x.png');
  opacity: 1;
}

.icon-17.disabled {
  background-image: url('../assets/images/editIcons/17-disabled@2x.png');
  opacity: 0.6;
}

.icon-18 {
  background-image: url('../assets/images/editIcons/18-disabled@2x.png');
  opacity: 1;
}

.icon-18.disabled {
  background-image: url('../assets/images/editIcons/18-disabled@2x.png');
  opacity: 0.6;
}

.icon-19 {
  background-image: url('../assets/images/editIcons/19-disabled@2x.png');
  opacity: 1;
}

.icon-19.disabled {
  background-image: url('../assets/images/editIcons/19-disabled@2x.png');
  opacity: 0.6;
}

.icon-20 {
  background-image: url('../assets/images/editIcons/20-active@2x.png');
}

.icon-21 {
  background-image: url('../assets/images/editIcons/21-active@2x.png');
}

.icon-22 {
  background-image: url('../assets/images/editIcons/22-active@2x.png');
}

.icon-23 {
  background-image: url('../assets/images/editIcons/23-disabled@2x.png');
  opacity: 1;
}

.icon-23.disabled {
  background-image: url('../assets/images/editIcons/23-disabled@2x.png');
  opacity: 0.6;
}

.icon-24 {
  background-image: url('../assets/images/editIcons/24-disabled@2x.png');
}

.icon-25 {
  background-image: url('../assets/images/editIcons/25-disabled@2x.png');
}

/* 小图标样式 */
.icon-2-small {
  background-image: url('../assets/images/editIcons/2-active@2x.png');
}

.icon-3-small {
  background-image: url('../assets/images/editIcons/3-active@2x.png');
}

.icon-4-small {
  background-image: url('../assets/images/editIcons/4-disabled@2x.png');
}

.icon-5-small {
  background-image: url('../assets/images/editIcons/5-disabled@2x.png');
}

.icon-6-small {
  background-image: url('../assets/images/editIcons/6-disabled@2x.png');
}

.icon-7-small {
  background-image: url('../assets/images/editIcons/7-disabled@2x.png');
}

/* 符号/单位弹窗样式 */
.symbol-unit-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  width: 460px;
  max-height: 600px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.dialog-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #7e57c2 0%, #9575cd 100%);
  border-radius: 8px 8px 0 0;
}

.dialog-title {
  font-size: 16px;
  font-weight: 500;
  color: white;
}

.close-btn {
  font-size: 20px;
  color: white;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.dialog-body {
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.search-box {
  width: 100%;
  margin-bottom: 10px;
}

.search-box input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.search-box input:focus {
  border-color: #7e57c2;
}

.symbol-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
}

.symbol-item {
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #eee;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  align-items: center;
}

.symbol-item:hover {
  background: #f5f0ff;
  border-color: #7e57c2;
}

.symbol {
  font-weight: 500;
  font-size: 16px;
  min-width: 30px;
  text-align: center;
}

.unit-name {
  font-size: 14px;
  color: #666;
}
</style>